import analyticUtils from '../../analytics-integrations/analytics-utils';

export const searchFormViewed = ({ location, activity }) => {
  if (!analyticUtils.segmentLoaded()) return;
  const searchId = PSSessions.Cookies('search_id');
  const properties = {
    location,
    activity,
    search_id: searchId
  };
  analytics.track('search form viewed', properties);
};

export const searchFormSubmitted = ({ location, activity }) => {
  if (!analyticUtils.segmentLoaded()) return;
  const searchId = PSSessions.Cookies('search_id');
  const properties = {
    location,
    activity,
    search_id: searchId
  };
  analytics.track('search form submitted', properties);
};
